import React 			from 'react';
import moment 	from	'moment';


import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdNavigation 	from '../common/_CrowdNavigation.jsx';
import SeriesInternalNav from '../common/_SeriesInternalNav.jsx';
import BDPSubmissionCard from '../common/_BDPSubmissionCard.jsx';
import BDPVideoGalleryBlock from '../common/_BDPVideoGalleryBlock.jsx';
import BDPHeader from '../common/_BDPHeader.jsx';
import BuildingInstructionsModalWithDownload from '../../modals/_BuildingInstructionsModalWithDownload.jsx';

import CrowdSubmissionResults from './_CrowdSubmissionResults.jsx';

export default class CrowdSeriesShipped extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			submissions: [],
			showDesigns: false,
			showInstructions: false,
			instructions: {}
		};

		this.finalists 			= blapp.models.get('submissions_finalists') || [];
		this.series 				= blapp.models.get('listSeries') || [];
		this.instructions		= blapp.models.get('instructions') || [];
		this.crowdData 			= blapp.models.get('crowdData') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.seriesContent 	= this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];
	}

	render() {
		const apacDate = moment(this.seriesContent.udtProductionStart).add(2, 'months').format('MMMM');

		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={1}/> : null}
				{this.state.showInstructions ? <BuildingInstructionsModalWithDownload pdfUrl={this.state.instructions.strURL} fileSize={this.state.instructions.nFileSize} idModel={this.state.instructions.idSubmission} closeFunc={() => this.toggleInstructionsModal(null)}/> : null}
				<BDPHeader series>
					<article className="notification notification--studio notification--warning l-margin-y--xl">
						<h1 className="text--small-title text--bold">Please note: for the Asia-Pacific region, sets will begin shipping in {apacDate} as planned</h1>
						<p>Shipping for other regions begins in {moment(this.seriesContent.udtProductionStart).format('MMMM')}. </p>
					</article>
				</BDPHeader>
				<SeriesInternalNav classes="bdp-series-main__series-nav--staggered bdp-series-main__series-nav-landing"/>
				<div className="main">
					<div className="main__content">
						<div className="edge-to-edge-container bdp-series-main__finalist-container bdp-series-main__finalist-container--series-past">
							<div className="edge-to-edge-container__internal">
								{this.renderSeriesFinalists()}
								<BDPVideoGalleryBlock finalists={this.finalists.data.submissions} seriesContent={this.seriesContent}/>
							</div>
						</div>
						<div className="bdp-series-main__finalist-drawer l-pad-top--null">
							<div className="bdp-series-main__finalist-drawer-trigger">
								<h2 className="text--bold text--small-title">Designs not chosen for crowdfunding</h2>
								<button className="btn btn--link l-flex l-center" onClick={() => this.setState({showDesigns: !this.state.showDesigns})}>{this.state.showDesigns ? 'Hide' : 'Show'} designs<i className={`l-margin-left--sm fas fa-caret-${this.state.showDesigns ? 'up' : 'down'}`}/></button>
							</div>
							{this.state.showDesigns && <CrowdSubmissionResults classes="bdp-series-main__finalist-drawer-content"/>}
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderSeriesFinalists() {
		const finalistCards = this.finalists.data.submissions.map(submission => <BDPSubmissionCard data={submission} salesInfo={this.crowdData.filter(item => item.idSubmission == submission.idSubmission)[0]} key={submission.idSubmission} hasVoting={false} hasPricing={false} hasInstructions={this.instructions.findIndex(item => item.idSubmission == submission.idSubmission) != -1} instructionsModal={(id) => this.toggleInstructionsModal(id)} classes="bdp-series-submissions__card"/>);

		return (
			<section className="bdp-series-past__finalists">
				<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">BDP {this.seriesContent.strName}</h2>
				<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
					{finalistCards}
				</section>
			</section>
		);
	}

	toggleInstructionsModal(id) {
		if(id != null) {
			this.setState({showInstructions: true, instructions: this.instructions[this.instructions.findIndex(item => item.idSubmission == id)]});		
		}else{
			this.setState({showInstructions: false})
		}

		blapp.screen.toggleScroll(!this.state.showInstructions);
	}
};